module.exports = __webpack_public_path__ + "img/yuewei.775896df.png";